<script setup lang="ts">
import FormTextarea from '@/core/forms/FormTextarea.vue';

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    label: string;
    maxlength: number;
    name: string;
    readonly?: boolean;
    value: string;
  }>(),
  {
    disabled: false,
    readonly: false,
  },
);

const emit = defineEmits<{
  commit: [value: string];
  'update:value': [value: string];
}>();
</script>

<template>
  <section class="flex flex-col">
    <h2 class="flex min-h-button items-center py-sm text-body font-semibold leading-[1.7] text-secondary">
      {{ props.label }}
    </h2>

    <FormTextarea
      :name="props.name"
      class="-mx-sm"
      auto-resize
      :commit-on-enter="false"
      :disabled="props.disabled"
      :readonly="props.readonly"
      :maxlength="props.maxlength"
      :value="props.value"
      :rows="1"
      theme="surface"
      :placeholder="$t('note.addAnnotationsPlaceholder')"
      @update:value="emit('update:value', $event)"
      @commit="emit('commit', $event)"
    />
  </section>
</template>
